import React from "react";
import "accountOwner/pages/Scheduler/components/SchedulerFilters/SchedulerFilters.scss";
import { prioritiesOptions } from "constants";

function PriorityCheckFilter({ setPriorityFilter, seletedPriorty }) {
  const handleChange = (e, item) => {
    const priority = [...seletedPriorty];
    const idx = priority?.findIndex((v) => +item.id === +v);
    if (e.target.checked) {
      priority.push(item.id);
    } else if (idx > -1) {
      priority.splice(idx, 1);
    }
    setPriorityFilter(priority);
  };

  return (
    <ul className={["filter-list"]}>
      {prioritiesOptions.map((item) => (
        <li key={item.id}>
          <div className="ch-checkbox">
            <label>
              <input
                type="checkbox"
                onChange={(e) => handleChange(e, item)}
                checked={seletedPriorty?.includes(item.id)}
              />
              <span> {item.name}</span>
            </label>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default PriorityCheckFilter;
